import axios from "axios";
import { API } from "@/lib/site";

const TOKEN_KEY = "ogvault_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export const adminLogin = (email, password) =>
  axios.post(`${API}/admin/login`, { email, password });

export const adminMe = () => axios.get(`${API}/admin/me`, { headers: authHeaders() });

export const uploadImage = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios.post(`${API}/admin/upload`, fd, {
    headers: { ...authHeaders(), "Content-Type": "multipart/form-data" },
  });
};

export const createPack = (data) =>
  axios.post(`${API}/admin/packs`, data, { headers: authHeaders() });

export const updatePack = (id, data) =>
  axios.put(`${API}/admin/packs/${id}`, data, { headers: authHeaders() });

export const deletePack = (id) =>
  axios.delete(`${API}/admin/packs/${id}`, { headers: authHeaders() });

export const listPacks = () => axios.get(`${API}/packs`);

export const apiErr = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  if (typeof d === "string") return d;
  return e?.message || "Fehler";
};
